import styled from 'styled-components';

import { paragraphLineHeight, sp } from '@main/theme';

/**
 * Wrapper for the NoValidScope component body.
 */
export const NoValidScopeBody = styled.div`
  max-width: ${sp(70)};
  text-align: center;
  line-height: ${paragraphLineHeight};

  & svg {
    margin: 0 auto 1em;
    display: flex;
    max-width: ${sp(7)};
    width: 100%;
  }
`;
